const dashboardGroups = {
  OVERVIEW: "Overview",
  FIRMWARE_UPDATE: "Firmware update",
  DIAGNOSTIC: "Diagnostic",
  DEVICE_SETTINGS: "Device settings",
  BATTERY_HEALTH: "Battery health"
};

export default dashboardGroups;
